import {
  ACCOUNT_ROLE_OWNER,
  ACCOUNT_ROLE_ADMIN,
} from 'constants/accountUserRoles';

export const isOwnerOrAdmin = (userRole) =>
  userRole === ACCOUNT_ROLE_OWNER || userRole === ACCOUNT_ROLE_ADMIN;
